import '../../bootstrap';

import Vue from 'vue'
import vuetify from '../../plugins/vuetify'
import VeeValidate from 'vee-validate';
import store from './store/index';
import VueRouter from "vue-router";
import router from './router';
import AuthApp from "./AuthApp";

Vue.use(VeeValidate);
Vue.use(VueRouter);

Vue.component('AuthApp', AuthApp);

new Vue({ vuetify, store, router }).$mount('#app');
